/**
 * @return {string}
 */
module.exports = function getRoiValueCalculatorEmailFormName() {
    return "ROI Value Calculator";
}